import type {
  HomeConfigData,
  LearnData,
  NoticeItem,
  TokenDetail,
} from '@/types/home';
import { get, post, getLocaleByUrl, Chain, isTestnet } from '@web3/base-utils';
export const getHomeConfig = () => {
  return get<HomeConfigData>('/spot/api/web3/content/home/configData');
};

export const getHotCoins = () => {
  const data = { orderType: 1, offset: 0, limit: 10, requestType: 0 };
  return post<{ coins: string[] }>(
    '/spot/api/web3/market/cryptocurrency/rank/list',
    data
  );
};

export const getNoticeData = () => {
  return get<NoticeItem[]>('/spot/api/web3/content/home/noticeData');
};

export interface ProjectListParams {
  chainId?: number | string;
  type?: number;
  start?: number;
  limit?: number;
  complete?: string;
  sort?: string;
  tick?: string;
  ticker?: string;
}
export interface Pagination<T> {
  total: number;
  list: T[];
}
export interface Project {
  tick: string;
  curPrice: string;
  changePrice: string;
  changePercent: string;
  btcVolume: string;
  amountVolume: string;
  totalVolume: string;
  protocolType: string;
  cap: string;
  deployBlocktime: number;
  totalMinted: number;
  historyCount: string;
}
export const getInscriptionList = (data?: ProjectListParams) => {
  return post<Pagination<Project>>(
    '/spot/api/web3/content/inscribe/v1/market/market_list',
    data
  );
};
export type NFTPro = {
  chainCode: string;
  contractAddress: string;
  name: string;
  logoUrl: string;
  bannerUrl: string;
  featuredUrl: string | null;
  largeImageUrl: string;
  itemsTotal: string;
  amountsTotal: string;
  ownersTotal: string;
  floorPrice: string;
  volume: string;
  sales: string;
  volumeChange: string;
  floorChange: string | null;
  verified: boolean;
};
export type NFTProQueryString = {
  volumeBy: number;
  from: number;
  size: number;
  chainCode: string;
};
export const getNFTProList = (data?: NFTProQueryString) => {
  return get<NFTPro[]>('/spot/api/nft/dex/v1/collection/popular', data);
};

const token = isTestnet
  ? 'cs65b620b8eb86994863f4c504'
  : 'cs206f84f291ab371e677827c5';

export type QueryTokenListParams = {
  // 链ID，可选参数，如果不传则默认为 "ALL"
  chainId?: string;
  // 内容，可选参数，根据长度判断是token还是合约地址
  content?: string;
  // 标签，可选参数，预留字段，可以是 "hot" 或 "top"
  tag?: string;
  // 排序字段，可选参数，默认为 "token"
  orderBy?: 'token' | 'price' | 'volume' | 'change';
  // 排序方向，可选参数，默认为 "asc"
  direction?: 'asc' | 'desc';
  // 翻页起始的tokenid，可选参数
  from?: number;
  // 单次请求数量限制，可选参数，默认为50
  limit?: number;
};

// 获取dex pro 币对列表
export const queryTokenList = (params: QueryTokenListParams) => {
  return get<TokenDetail[]>('/web3/api/quote/v1/token/suggest', params);
};

export const getChains = () => {
  return get<{ walletChains: { CLOUD: { itemList: Chain[] } } }>(
    '/web3/wallet/v1/private/mgmt/chain/list',
    {
      type: 1,
    }
  );
};
